/* PPC Tracking Script */
loadScriptCMM(
  '//cdn.rlets.com/capture_configs/ddc/906/777/6114b4c8b098cb58f357eed.js',
  null,
  { async: true },
);
/* Interactions */
loadInteractionsScript(
  'https://grow.creekmoremarketing.com/embed/v6/76916/1/1540432627/1e338e963df2b59c1ac8cc8c21928dfa3bdd659e0ecc357a',
);

/* Header Contact Banner */
CMMBanner.make(
  [
    {
      text: [
        {
          content:
            'Proudly serving Marriottsville, Maryland (MD), and the surrounding areas',
        },
      ],
    },
    {
      text: CMMBanner.createSimpleButtons([
        CMMBanner.Button.Presets.DIRECTIONS({
          link: 'http://www.google.com/maps/search/?api=1&query=Windo+Vango+2020+Marriottsville+Rd+Ste+E%2CMarriottsville%2CMD+21104-1541',
        }),
        CMMBanner.Button.Presets.PHONE({
          text: '(410) 521-1700',
          link: 'tel:+14105211700',
        }),
        CMMBanner.Button.Presets.SMS({
          link: 'sms:+14103527512',
        }),
      ]),
    },
  ],
  {
    presets: [CMMBanner.Presets.HEADER_CONTACT],
  },
);

/* Site-Wide Banner */
deferJQuery(function () {
  headerBannerMultipleColumns(
    [
      {
        text: "<a style='font-weight:600;' href='/more-products-services/products/custom-drapery-and-valances'>Custom Cornices & Valances</a>, <a style='font-weight:600;' href='/more-products-services/products/decorative-faux-iron-grilles'>Decorative Faux Iron Grilles</a>, and <a style='font-weight:600;' href='/more-products-services/services/blind-shade-shutter-repair-services'>Window Covering Repairs</a>",
        bgColor: '',
        txtColor: '#fff',
        linkColor: '#fff',
        border: '0',
        column_min_width: '50%',
        classname: '',
      },
      {
        text: "<h2>Request a Consultation <div class='cmm-button-group'><a class='cmm-button cmm-button-hd-colors' href='tel:+14105211700'>(410) 521-1700</a><a class='cmm-button cmm-button-gray-black' href='sms:++14103527512'>Text Us</a><a target='_blank' class='cmm-button cmm-button-white-black' href='http://www.google.com/maps/search/?api=1&query=Windo+Vango+2020+Marriottsville+Rd+Ste+E%2CMarriottsville%2CMD+21104-1541'>Directions</a></div></h2><h4>Proudly serving Marriottsville, Maryland (MD), and the surrounding areas</h4>",
        bgColor: '#fafafa',
        txtColor: '#000',
        border: '0',
        padding: '1rem',
        classname: '',
      },
    ],
    {
      padding: '1rem 0 0',
      border: {
        border_bottom: '1px solid #ddd',
      },
      column_min_width: '100%',
      classname: 'cmm-header-banner-fullwidth',
    },
  );
  /* Smooth Scrolling */
  cmmSmoothScrollInit();
});

/* Leave a Review Button */
if (['about/about', 'contact'].includes(strPath)) {
  deferJQuery(function () {
    headerBannerMultipleColumns(
      [
        {
          text: "<a class='cmm-button cmm-leave-a-review cmm-leave-a-review-fredrick' target='_blank' href='https://grow.creekmoremarketing.com/windo-vango-164460080704837/review-us?dashboard=1'>REVIEW US - FREDRICK</a> <a style='margin-top:15px' class='cmm-button cmm-leave-a-review cmm-leave-a-review-marriottsville' target='_blank' href='https://grow.creekmoremarketing.com/windo-vango-164071668632450/review-us?dashboard=1'>REVIEW US -  MARRIOTTSVILLE</a>",
          bgColor: '#fff',
          linkColor: '#fff',
          linkHoverColor: '#fff',
          padding: '0',
          margin: '0',
        },
      ],
      {
        bgColor: '#fff',
        column_min_width: '100%',
        padding: '0',
        margin: '0 0 15px',
        selector:
          '.cmm-path-about_about #cmm-leave-a-review .cmp-text, .cmm-path-contact #cmm-leave-a-review .cmp-text',
        position: 'after',
      },
    ).then(() => {
      cmmSetupEventTracking([
        {
          selector: 'a.cmm-leave-a-review-fredrick',
          action: 'Leave a Review - Amplify Button Fredrick',
          event: 'click',
        },
        {
          selector: 'a.cmm-leave-a-review-marriottsville',
          action: 'Leave a Review - Amplify Button Marriottsville',
          event: 'click',
        },
      ]);
    });
  });
}

/* Text Us & Leave a Review Buttons */
if (strPath == 'request-consultation') {
  deferJQuery(function () {
    headerBannerMultipleColumns(
      [
        {
          text: "<div class='cmm-button-group'><a class='cmm-button cmm-button--size-small cmm-text-us' href='sms:+14103527512'>Text Us</a><a class='cmm-button cmm-button--size-small cmm-leave-a-review cmm-leave-a-review-fredrick' target='_blank' href='https://grow.creekmoremarketing.com/windo-vango-164460080704837/review-us?dashboard=1'>REVIEW US - FREDRICK</a><a style='margin-top:15px' class='cmm-button cmm-button--size-small cmm-leave-a-review cmm-leave-a-review-marriottsville' target='_blank' href='https://grow.creekmoremarketing.com/windo-vango-164071668632450/review-us?dashboard=1'>REVIEW US -  MARRIOTTSVILLE</a></div>",
          bgColor: '#fff',
          linkColor: '#fff',
          linkHoverColor: '#fff',
          padding: '0',
          margin: '0',
        },
      ],
      {
        bgColor: '#fff',
        column_min_width: '100%',
        padding: '0',
        margin: '15px 0',
        selector: '#request-a-consultation',
        position: 'after',
      },
    ).then(() => {
      cmmSetupEventTracking([
        {
          selector:
            '.cmm-path-request-consultation a.cmm-text-us[href="sms:+14103527512"]',
          action: 'Text Us - Request a Consultation',
          event: 'click',
        },
        {
          selector: 'a.cmm-leave-a-review-fredrick',
          action: 'Leave a Review - Amplify Button Fredrick',
          event: 'click',
        },
        {
          selector: 'a.cmm-leave-a-review-marriottsville',
          action: 'Leave a Review - Amplify Button Marriottsville',
          event: 'click',
        },
      ]);
    });
  });
}

/* Custom Event Tracking */
cmmSetupEventTracking([
  {
    selector: '.cmp-navigation__item a[href="/request-consultation"]',
    action: 'Request Consultation - Menu',
    event: 'click',
  },
]);

/* ConvertBoost© */
cmmSetupConvertBoost({
  cta_options: [
    {
      mode: 'modal',
      icon: 'phone',
      icon_size: 'wti',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['desktop', 'laptop', 'tablet', 'mobile'],
      font: {
        family: 'AUTO',
      },
    },
  ],
  modal_options: {
    header_text:
      '<img style="max-width:300px;" src="https://assets.hunterdouglas.com/content/dam/dealer-logos/w/windo-vango-237729/WIVRET.png">',
    header_color: '#ffffff',
    description_text:
      'Ready to transform your space?<br>Our design team is here to help!',
    font: {
      family: 'AUTO',
    },
    buttons: [
      {
        title: '(410) 521-1700',
        description: 'Marriottsville, MD',
        link: 'tel:+14105211700',
        txt_color_hover: '#f5842a',
        bg_color: '#f5842a',
        class_list: ['call-marriottsville-showroom'],
        icon: 'phone',
      },
      {
        title: 'VISIT SHOWROOM',
        description: 'Marriottsville, MD',
        link: 'http://www.google.com/maps/search/?api=1&query=Windo+Vango+2020+Marriottsville+Rd+Ste+E%2CMarriottsville%2CMD+21104-1541',
        link_target: '_blank',
        txt_color_hover: '#f5842a',
        bg_color: '#f5842a',
        class_list: ['visit-marriottsville-showroom'],
        icon: 'map-pin',
      },
      {
        title: 'REQUEST A CONSULTATION',
        description: ' ',
        link: 'https://www.windovango.com/request-consultation',
        bg_color: '#f5842a',
        // bg_color_hover: '#f9903c',
        txt_color_hover: '#f5842a',
        class_list: ['request-a-consultation'],
        icon: 'email',
      },
    ],
    footer_text:
      'Windo Vango aims to be your premier source for window coverings and window covering motorization throughout the greater Baltimore area!',
    footer_color: '#5b6770',
  },
}).then((_) => {
  /* ConvertBoost© Event Tracking */
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-marriottsville-showroom',
      action: 'Call Marriottsville Showroom - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .visit-marriottsville-showroom',
      action: 'Visit Marriottsville Showroom - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .request-a-consultation',
      action: 'Request a Consultation - ConvertBoost©',
      event: 'click',
    },
  ]);
});

/* Site-Wide Footer Blurb */
var txtFooter =
  'At Windo VanGo our designers will come to your home and professionally measure your windows, show you samples and provide solutions to meet your decor and lifestyle needs. We are the premier Hunter Douglas window covering dealer with the best in blinds, shutters, shades, drapery, curtains, and more. We also offer free design consultations that allow you to plan for your purchases. Windo VanGo has one of the largest window covering showrooms in Maryland. Come and visit us! We are proud to serve the surrounding area including New Market, Ellicott City, Columbia, Clarksville, Edgewater, Annapolis, Cockeysville, Crofton, Lutherville-Timonium, Towson, Elkridge, Benson, Howard, Frederick, Baltimore, Harford, & Carroll Counties, MD';
footerBlurb(txtFooter);

/* Custom Metadata */
cmmUpdateMetadata({
  'hunter-douglas/shades/sheer-shades': {
    t: 'Hunter Douglas Sheer Shades | Windo Vango',
    d: 'Find perfect sheer window shades from Hunter Douglas at Windo Vango near Howard, Frederick, Baltimore, Harford, and Carroll Counties, Maryland.',
  },
  'hunter-douglas/shades/cellular-shades': {
    t: 'Hunter Douglas Cellular Shades | Windo Vango',
    d: 'Upgrade your home with Hunter Douglas Honeycomb Shades at Windo Vango near Howard, Frederick, Baltimore, Harford, and Carroll Counties, Maryland.',
  },
  'hunter-douglas/shades/roman-shades': {
    t: 'Hunter Douglas Roman Shades | Windo Vango',
    d: 'Introduce Hunter Douglas Roman Shades to your home with Windo Vango',
  },
  'hunter-douglas/shades/roller-shades': {
    t: 'Hunter Douglas Roller Shades | Windo Vango',
    d: 'Find the perfect roller shades for your home at Windo Vango near Howard, Frederick, Baltimore, Harford, and Carroll Counties, Maryland.',
  },
  'hunter-douglas/shades/woven-shades': {
    t: 'Hunter Douglas Woven Shades | Windo Vango',
    d: 'Woven Wood Shades, Bamboo Shades, and Bamboo Blinds from Hunter Douglas at Windo Vango.',
  },
  'hunter-douglas/shades/vertical-shades': {
    t: 'Vertical Shades | Windo Vango',
    d: 'Vertical Shades for Sliding Doors from Hunter Douglas at Windo Vango near Howard, Frederick, Baltimore, Harford, and Carroll Counties, Maryland.',
  },
  'hunter-douglas/shutters': {
    t: 'Hunter Douglas Plantation Shutters | Windo Vango',
    d: 'Introduce elegance and timeless style through our plantation shutters! Hunter Douglas window shutters available at Windo Vango.',
  },
  'hunter-douglas/blinds/vertical-blinds': {
    t: 'Hunter Douglas vertical Blinds | Windo Vango',
    d: 'Premium vertical blinds available at  Windo Vango near Howard, Frederick, Baltimore, Harford, and Carroll Counties, Maryland.',
  },
  'hunter-douglas/blinds/wood-blinds': {
    t: 'Hunter Douglas Wood Blinds | Windo Vango',
    d: 'Premium wood window blinds available at  Windo Vango near Howard, Frederick, Baltimore, Harford, and Carroll Counties, Maryland.',
  },
  'hunter-douglas/blinds/metal-blinds': {
    t: 'Hunter Douglas metal Blinds | Windo Vango',
    d: 'Premium aluminum blinds available at Windo Vango near Howard, Frederick, Baltimore, Harford, and Carroll Counties, Maryland.',
  },
  'hunter-douglas/drapery': {
    t: 'Hunter Douglas Drapery | Windo Vango',
    d: 'Drapery, Valance Curtains, and Living Room Curtains from Hunter Douglas at Windo Vango near Howard, Frederick, Baltimore, Harford, and Carroll Counties, Maryland.',
  },
  'hunter-douglas/powerview-automation': {
    t: 'Motorized Blinds, Automatic Blinds | Windo Vango',
    d: 'Modernize your home with motorized blinds. Raise and lower the with press of a button or voice command.',
  },
  'hunter-douglas/featured/room-darkening': {
    t: 'Room Darkening | Windo Vango',
    d: 'Find the perfect blackout curtains and shades for your home! Check out more at Windo Vango',
  },
  'hunter-douglas/featured/energy-efficient': {
    t: 'Energy Efficiency | Windo Vango',
    d: 'Create a more energy efficiency home with Windo Vango. Our products can help your home and lower your bill.',
  },
  'hunter-douglas/featured/light-enhancing': {
    t: 'Light Enhancing | Windo Vango',
    d: 'Perfectly control the light in your home. Using products from Hunter Douglas and Windo Vango',
  },
  'hunter-douglas/featured/door-coverings': {
    t: 'Door Covering | Windo Vango',
    d: 'Find the ideal door cover with Hunter Douglas! Products available at Windo Vango',
  },
  'hunter-douglas/featured/sound-absorption': {
    t: 'Sound Absorption | Windo Vango',
    d: 'Increase comfort in your home through our sound absorbent drapes and shades.',
  },
  'hunter-douglas/featured/top-down-bottom-up-shades': {
    t: 'Top-Down, Bottom-Up | Windo Vango',
    d: 'Perfect the privacy and light control in your home.',
  },
});

/* Reviews Page */
if (strPath === 'about/customer-reviews-for-windo-vango-md') {
  function cmmInteractionsWaitForReviews(
    parent: Element,
    selector: string,
  ): Promise<HTMLElement | null> {
    const promise = new Promise<HTMLElement>((resolve, reject) => {
      function wait() {
        const widget = parent.querySelector<HTMLElement>(selector);
        if (widget) {
          resolve(widget);
        } else {
          setTimeout(wait, 50);
        }
      }
      wait();
    });
    return promise.catch((e) => {
      console.log(e);
      return null;
    });
  }

  let titleLocation1 = document.createElement('h2');
  titleLocation1.textContent = 'Fredrick';
  titleLocation1.classList.add('cmp-title__text');
  titleLocation1.style.textAlign = 'center';

  let titleLocation2 = document.createElement('h2');
  titleLocation2.textContent = 'Marriottsville';
  titleLocation2.classList.add('cmp-title__text');
  titleLocation2.style.textAlign = 'center';

  // create more location titles if needed

  const parent = document.querySelector('#bf-revz-widget-9876543213315183');
  cmmInteractionsWaitForReviews(
    parent,
    'iframe[src*="bid=164460080704837"]',
  ).then((widget) => {
    parent.insertBefore(titleLocation1, widget);
  });
  cmmInteractionsWaitForReviews(
    parent,
    'iframe[src*="bid=164071668632450"]',
  ).then((widget) => {
    parent.insertBefore(titleLocation2, widget);
  });

  // insert any additional titles created (note: titleLocation# variable name)
}
